import { useNavigate } from 'react-router-dom';
import { GH } from '../theme';
import { GHLogo } from './GHLogo';
import { useWindowWidth } from '../hooks/useWindowWidth';

function FootCol({ title, links, navigate }) {
  return (
    <div>
      <div style={{ fontFamily: GH.fonts.body, fontSize: 11, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: GH.colors.onDark.muted, marginBottom: 20 }}>{title}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {links.map(l => (
          <a key={l.label} onClick={(e) => { e.preventDefault(); navigate(l.path); }} href={l.path}
            style={{ fontFamily: GH.fonts.body, fontSize: 14, color: GH.colors.onDark.body, textDecoration: 'none', cursor: 'pointer', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#fff'}
            onMouseLeave={e => e.currentTarget.style.color = GH.colors.onDark.body}
          >{l.label}</a>
        ))}
      </div>
    </div>
  );
}

export function Footer() {
  const navigate = useNavigate();
  const w = useWindowWidth();
  const mob = w < 768;
  return (
    <footer style={{ background: GH.colors.charcoalDeep, padding: mob ? '64px 20px 40px' : '80px 40px 40px' }}>
      <div style={{ maxWidth: 1300, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: mob ? '1fr' : '1.5fr 1fr 1fr 1fr', gap: mob ? 40 : 48, paddingBottom: 48, borderBottom: `1px solid ${GH.colors.onDark.border}` }}>
          <div>
            <div style={{ marginBottom: 20, cursor: 'pointer' }} onClick={() => navigate('/')}>
              <GHLogo scale={0.85} />
            </div>
            <p style={{ fontFamily: GH.fonts.body, fontSize: 14, color: GH.colors.onDark.body, lineHeight: 1.7, maxWidth: 320, marginBottom: 20 }}>
              Auckland's trusted partner for construction and property services. Quality workmanship, transparent pricing, professional delivery.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontFamily: GH.fonts.body, fontSize: 14, color: GH.colors.onDark.body }}>
              <span>info@greyholm.co.nz</span>
            </div>
          </div>
          <FootCol title="Services" navigate={navigate} links={[
            { label: 'Construction', path: '/services' },
            { label: 'Maintenance', path: '/services' },
            { label: 'Window Cleaning', path: '/services' },
            { label: 'Water Blasting', path: '/services' },
          ]} />
          <FootCol title="Company" navigate={navigate} links={[
            { label: 'About Us', path: '/about' },
            { label: 'Contact', path: '/contact' },
            { label: 'Get a Quote', path: '/quote' },
          ]} />
          <FootCol title="Contact" navigate={navigate} links={[
            { label: '020 4198 1876', path: '/contact' },
            { label: 'info@greyholm.co.nz', path: '/contact' },
            { label: 'Hillpark, Auckland', path: '/contact' },
          ]} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 28, flexWrap: 'wrap', gap: 16 }}>
          <span style={{ fontFamily: GH.fonts.body, fontSize: 13, color: GH.colors.onDark.muted }}>© 2026 GreyHolm Group. All rights reserved.</span>
          <span style={{ fontFamily: GH.fonts.body, fontSize: 13, color: GH.colors.gold, letterSpacing: '0.06em', opacity: 0.7 }}>Built on Precision.</span>
        </div>
      </div>
    </footer>
  );
}
